import terms from "./content/terms-of-use.json"
import privacy from "./content/privacy-policy.json"
import stateNotices from "./content/state-privacy-notices.json"

export type DocumentType = "terms-of-use" | "privacy-policy" | "state-privacy-notices"

export interface LegalContent {
  text: string
  format: string
  title?: string | null
  metadata?: { effectiveDate?: string; checkboxText?: string; instructions?: string } | null
}

export const TERMS_DOCUMENT = "MASTERY_PREP_TERMS"

// Legacy AOP terms, used as the fallback document when MASTERY_PREP_TERMS can't load.
export const AOP_DOCUMENT = "AOP"

export const legalDocuments: Record<DocumentType, LegalContent> = {
  "terms-of-use": terms,
  "privacy-policy": privacy,
  "state-privacy-notices": stateNotices
}

export const documentFromLink = (href: string): DocumentType | undefined => {
  const key = href.slice(1)
  return href.startsWith("#") && Object.prototype.hasOwnProperty.call(legalDocuments, key)
    ? key as DocumentType
    : undefined
}

export const headingId = (text: string) =>
  text.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "")
